export * from './agris-nueva-cotizacion-page.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-nueva-cotizacion-page/index.ts